// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1JZTr","card":"Cards_card__5pOyC","infected":"Cards_infected__2ynhk","recovered":"Cards_recovered__1ScZO","deaths":"Cards_deaths__291at"};